<template>
  <div>
    <vue-dropzone
      ref="myVueDropzone"
      id="dropzone"
      :options="this.option"
      @vdropzone-error-multiple="processError"
      @vdropzone-success-multiple="processSuccess"
      @vdropzone-sending="sending"
    >
    </vue-dropzone>
    <div class="info">
      <b class="text-red">※ファイルのアップロードは「アップロード」ボタンを押すことで完了となります。</b>
      <br>
      <span>※アップロードボタンを押した後、アップロード完了するまでしばらくお待ちください</span>
    </div>
    <div v-if="shareLink">
      <div class="text-left m-t">
        <span class="fa fa-check-circle-o" aria-hidden="true" style="color: #5cb85c">
          <a :href="shareLink" target="_blank" class="share-link">アップロード済みファイル確認</a>
        </span>
      </div>
    </div>
    <div class="text-right m-t">
      <button
        class="btn btn-warning m-w-120"
        @click="updateFiles"
      >
        アップロード
      </button>
      <button type="button" class="btn m-w-120" data-dismiss="modal" @click="$emit('close')">閉じる</button>
    </div>
  </div>
</template>

<script>
import vue2Dropzone from 'vue2-dropzone'
import store from '@/store'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'

export default {
  props: {
    option: {
      type: Object
    },
    asin: {
      type: String
    },
    shareLink: {
      type: String
    }
  },
  components: {
    vueDropzone: vue2Dropzone
  },
  data () {
    return {
      loader: null,
      uploadErrorMessage: `
        <span class="text-red font-bold"><i class="fa fa-exclamation-triangle text-size-20 mr-r-5" aria-hidden="true"></i>審査用データのアップロードに失敗しました</span><br><br>
        ・ しばらく時間をおいて再度お試しください。<br>
        ・ 繰り返しエラーとなる場合は、Chatworkにてデータをご送付ください。
      `
    }
  },
  beforeDestroy () {
    this.$emit('close')
    $('.modal-backdrop').remove()
  },
  methods: {
    sending (file, xhr, formData) {
      formData.append('asin', this.asin)
    },
    processError (file, response) {
      store.commit('toggleModal', {
        show: true,
        message: this.uploadErrorMessage,
        modalWidth: 600
      })
      self.loader && self.loader.hide()
    },
    processSuccess (file, response) {
      store.commit('toggleModal', {
        show: true,
        message: '審査用画像のアップロードに成功しました'
      })
      this.$emit('refresh')
      self.loader && self.loader.hide()
    },
    updateFiles () {
      if (this.$refs.myVueDropzone.getQueuedFiles().length) {
        self.loader = this.$loading.show()
        this.$refs.myVueDropzone.processQueue()
        this.$emit('close')
      } else {
        this.$emit('close')
      }
    }
  },
  watch: {
    asin (newVal, oldVal) {
      this.$refs.myVueDropzone.removeAllFiles()
    }
  }
}
</script>

<style scoped>
.info {
  margin-top: 8px;
}

.share-link {
  margin-right: 24px;
}
</style>



// WEBPACK FOOTER //
// src/components/ImageInput.vue